/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { renderValidation, validatePassword } from '../../lib/validation';
import { passwordLabels } from '../../lib/i18n';

const AUNewPasswordComponent = ({
  lang,
  saving,
  errorMessages,
  setErrorMessages,
  newPassword,
  newPasswordValidated,
  newPasswordValidationMessages,
  setNewPassword,
  setNewPasswordValidated,
  setNewPasswordValidationMessages,
  confirmPassword,
  confirmPasswordValidated,
  confirmPasswordValidationMessages,
  setConfirmPassword,
  setConfirmPasswordValidated,
  setConfirmPasswordValidationMessages,
}) => {
  const [errorMessagesSet, setErrorMessagesSet] = useState(false);

  useEffect(() => {
    if (errorMessages.length > 0 && !errorMessagesSet) {
      setNewPasswordValidationMessages([]);
      setConfirmPasswordValidationMessages([]);
      setErrorMessagesSet(true);
    } else if (errorMessages.length === 0 && errorMessagesSet) {
      setErrorMessagesSet(false);
    }
  });

  let newPasswordValidationClassName = '';
  if (errorMessages.length > 0
    || (newPasswordValidationMessages.length > 0 && !newPasswordValidated)) {
    newPasswordValidationClassName = ' form-info--error';
  } else if (newPasswordValidated) {
    newPasswordValidationClassName = ' form-info--confirmed';
  }

  let confirmPasswordValidationClassName = '';
  if (errorMessages.length > 0
    || (confirmPasswordValidationMessages.length > 0 && !confirmPasswordValidated)) {
    confirmPasswordValidationClassName = ' form-info--error';
  } else if (confirmPasswordValidated) {
    confirmPasswordValidationClassName = ' form-info--confirmed';
  }

  return (
    <div className="row__item row__item--basis-default-line-width">
      <div className={`form__field${newPasswordValidationClassName}`}>
        <label htmlFor="new-password">
          {passwordLabels[lang].newPassword}
          <span className="form-info__hint">{passwordLabels[lang].newPasswordInfo}</span>
          {renderValidation(errorMessages)}
        </label>
        {renderValidation(newPasswordValidationMessages)}
        <input
          type="password"
          id="new-password"
          value={newPassword}
          onChange={(e) => {
            const newValue = e.target.value;
            validatePassword(lang, newValue, confirmPassword).then((v) => {
              setNewPassword(newValue);
              setConfirmPassword('');
              setNewPasswordValidated(v.newPasswordValid);
              setNewPasswordValidationMessages(v.newPasswordMessages);
              setConfirmPasswordValidationMessages([]);
              setErrorMessages();
            });
          }}
          onBlur={(e) => {
            const newValue = e.target.value;
            validatePassword(lang, newValue, confirmPassword, true).then((v) => {
              setNewPasswordValidated(v.newPasswordValid);
              setNewPasswordValidationMessages(v.newPasswordMessages);
            });
          }}
          disabled={saving}
        />
      </div>
      <div className={`form__field${confirmPasswordValidationClassName}`}>
        <label htmlFor="repeated-password">{passwordLabels[lang].repeatPassword}</label>
        {renderValidation(confirmPasswordValidationMessages)}
        <input
          type="password"
          id="repeated-password"
          value={confirmPassword}
          onChange={(e) => {
            const newValue = e.target.value;
            validatePassword(lang, newPassword, newValue).then((v) => {
              setConfirmPassword(newValue);
              setConfirmPasswordValidated(v.confirmPasswordValid);
              setConfirmPasswordValidationMessages(v.confirmPasswordMessages);
            });
          }}
          onBlur={(e) => {
            const newValue = e.target.value;
            validatePassword(lang, newPassword, newValue, true).then((v) => {
              setConfirmPasswordValidated(v.confirmPasswordValid);
              setConfirmPasswordValidationMessages(v.confirmPasswordMessages);
            });
          }}
          disabled={saving}
        />
      </div>
      <div className="submit">
        <div className={`${saving ? 'submit-input-wrapper--processing' : ''}`}>
          <input
            className="button"
            type="submit"
            value={passwordLabels[lang].changePassword}
            disabled={saving}
          />
        </div>
      </div>
    </div>
  );
};

AUNewPasswordComponent.defaultProps = {
  errorMessages: [],
  setErrorMessages: () => {},
};

AUNewPasswordComponent.displayName = 'AUNewPasswordComponent';
AUNewPasswordComponent.propTypes = {
  lang: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  setErrorMessages: PropTypes.func,
  newPassword: PropTypes.string.isRequired,
  newPasswordValidated: PropTypes.bool.isRequired,
  newPasswordValidationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  setNewPassword: PropTypes.func.isRequired,
  setNewPasswordValidated: PropTypes.func.isRequired,
  setNewPasswordValidationMessages: PropTypes.func.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  confirmPasswordValidated: PropTypes.bool.isRequired,
  confirmPasswordValidationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  setConfirmPassword: PropTypes.func.isRequired,
  setConfirmPasswordValidated: PropTypes.func.isRequired,
  setConfirmPasswordValidationMessages: PropTypes.func.isRequired,
};
export default AUNewPasswordComponent;
